import React from 'react';
import { Routes, Route } from 'react-router-dom'
import Header from './components/Header/Header';
import './App.css';
import FixedCallButton from './components/FixedCallButton/FixedCallButton';
import Footer from './components/Footer/Footer';
import CampaignsPage from './components/CampaignsPage/CampaignsPage';
import CampaignDetailPage from './components/CampaignsPage/CampaignDetailPage';
import ContactPage from './components/Contact/Contact';
import ScrollToTop from './components/ScrollToTop';
import SpeedTest from './components/SpeedTest/SpeedTest';
import KvkkPage from './components/KvkkPage';
import CookiePolicyPage from './components/CookiePolicyPage';
import HomePage from './components/HomePage';

function App() {
  return (
    <div className="App">
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/kampanyalar" element={<CampaignsPage />} />
        <Route path="/kampanyalar/:providerId/:campaignId" element={<CampaignDetailPage />} />
        <Route path="/iletisim" element={<ContactPage />} />
        <Route path="/hiz-testi" element={<SpeedTest />} />
        <Route path="/kvkk" element={<KvkkPage />} />
        <Route path="/cerez-politikasi" element={<CookiePolicyPage />} />
      </Routes>
      <Footer />
      <FixedCallButton />
    </div>
  );
}

export default App;